import localforage from'localforage'

const store = localforage.createInstance({name: 'app.cache'});
const CACHE_VALIDITY_TIME = 60*60*8*1000;
const DICT = {}

export const CacheService = {
    putTemp(key, val) {
        DICT[key] = val
    },
    getTemp(key) {
        return DICT[key]
    },
    put(key, val){
        store.setItem(key, {
            validity: new Date().getTime(),
            items: val
        })
    },
    get(key) {
        return store.getItem(key)
            .then((data) => {
                if(data) {
                    if(!data.validity){
                        store.removeItem(key)
                        return Promise.resolve(null);
                    } else {
                        if(data.validity <= new Date().getTime() + CACHE_VALIDITY_TIME){
                            return Promise.resolve(data.items)
                        } else {
                            return Promise.resolve(null)
                        }
                    }
                }
                return Promise.resolve(null)
            })
    }
}

export default {
    install(Vue){
        Vue.prototype.$cache = CacheService
    }
}
export const localStore = store
